import React from 'react';
import {
  useGetList,
  SelectInput,
  Loading,
  useRecordContext,
} from "react-admin";

export const CachedCategoriesInput = React.forwardRef((props, ref) => {
  const { filter: filterFromProps, source, ...restProps } = props;
  const record = useRecordContext();

  const { data, loading, error } = useGetList("categories", {
    pagination: { page: 1, perPage: props.perPage || 200 },
    sort: { field: "name", order: "ASC" },
    filter: filterFromProps || {},
  });

  if (loading) return <Loading />;
  if (error) return <span>Error al cargar las categorías</span>;

  // Determinar el valor inicial
  let initialValue = null;
  if (record) {
    if (record.category?.id) {
      initialValue = record.category.id;
    } else if (record.categoryId) {
      initialValue = record.categoryId;
    }
  }

  const { filter, ...selectInputProps } = restProps;

  return (
    <SelectInput
      {...selectInputProps}
      source={source}
      ref={ref}
      choices={data}
      optionText="name"
      allowEmpty={true}
      emptyText="Es una categoría Padre"
      parse={(value) => {
        if (value === "" || value === undefined || value === null) return null;
        if (typeof value === "object" && value !== null) return value.id;
        return value;
      }}
      format={(value) => {
        if (value === null || value === undefined) return "";
        if (typeof value === "object" && value !== null) return value.id;
        return value;
      }}
      defaultValue={initialValue}
    />
  );
});
